import React, {Component} from 'react';
import {Overlay} from '../Overlay';
import './styles.less';

export function LoadingOverlay() {
    return <Overlay className="loading-overlay" />;
}


export function loadingPlaceholder(ComposedComponent) {
    return class extends Component {
        static displayName = `loadingPlaceholder(${ComposedComponent.name})`

        render() {
            const {isLoading, children, ...props} = this.props;
            return (
                <ComposedComponent isLoading={isLoading} {...props}>
                    {isLoading && <LoadingOverlay />}
                    {children}
                </ComposedComponent>
            );
        }
    };
}
